{
  "version": 1,
  "asset_id": "b88311c9-1f38-41ff-a5a4-2c2b598c239a",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/b88311c9-1f38-41ff-a5a4-2c2b598c239a/texas-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/b88311c9-1f38-41ff-a5a4-2c2b598c239a/texas-640.avif",
  "original_filename": "texas-640.avif",
  "size": 12700,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:27:05Z"
}
